class FitmentFormWrap {
  constructor(element) {
    this.element = element;
    this.currentVehicleElement = null;
    this.fitmentFormElement = null;
    this.isInitialized = false;
    
    this.init();
  }

  init() {
    if (this.isInitialized) return;
    
    // Find child elements
    this.findChildElements();
    
    // Check persisted/current fitment state and update visibility
    this.checkVehicleHistory();
    this.element.classList.add('fitment-form-wrap-hydrated');
    
    this.isInitialized = true;
  }

  findChildElements() {
    this.currentVehicleElement = this.element.querySelector('current-vehicle');
    this.fitmentFormElement = this.element.querySelector('fitment-form');
    
    // Log warning if elements aren't found
    if (!this.currentVehicleElement) {
      console.warn('FitmentFormWrap: <current-vehicle> child element not found');
    }
    
    if (!this.fitmentFormElement) {
      console.warn('FitmentFormWrap: <fitment-form> child element not found');
    }
  }

  checkVehicleHistory() {
    const currentUrlFitment = new URLSearchParams(window.location.search).get('filter.p.m.custom.vehicle_fitment');
    const hasCurrentUrlFitment = /^gid:\/\/shopify\/Metaobject\/\d+$/.test(currentUrlFitment || '');

    if (hasCurrentUrlFitment || window.vehicleFitmentController?.getCurrentId?.()) {
      this.showCurrentVehicle();
      return;
    }

    const vehicleHistory = window.ThemeStorage?.getJson?.('vehicle_fitment_history', {
      current: null,
      history: [],
    });

    if (vehicleHistory?.current) {
      this.showCurrentVehicle();
    } else {
      this.showFitmentForm();
    }
  }

  showCurrentVehicle() {
    if (this.currentVehicleElement) {
      this.currentVehicleElement.classList.remove('hidden');
    }
    
    if (this.fitmentFormElement) {
      this.fitmentFormElement.classList.add('hidden');
    }
  }

  showFitmentForm() {
    if (this.fitmentFormElement) {
      this.fitmentFormElement.classList.remove('hidden');
    }
    
    if (this.currentVehicleElement) {
      this.currentVehicleElement.classList.add('hidden');
    }
  }

  // Public method to refresh the display based on current fitment state
  refresh() {
    this.checkVehicleHistory();
    this.fitmentFormElement?.populateCollectionFiltersWithEnhancement();
  }

  prefillFromFitmentPath(path) {
    this.showFitmentForm();
    return Boolean(this.fitmentFormElement?.prefillFromFitmentPath?.(path));
  }

  destroy() {
    // Cleanup if needed
    this.isInitialized = false;
    this.currentVehicleElement = null;
    this.fitmentFormElement = null;
  }
}

// Add this to the FitmentFormWrap initialization code
window.fitmentFormInstances = window.fitmentFormInstances || new Map();

window.initializeFitmentFormWraps = function(root = document) {
  const fitmentWraps = root.querySelectorAll('fitment-form-wrap');

  fitmentWraps.forEach((element) => {
    let instance = window.fitmentFormInstances.get(element);

    if (!instance) {
      instance = new FitmentFormWrap(element);
      window.fitmentFormInstances.set(element, instance);
    } else {
      instance.findChildElements();
      instance.refresh();
    }

    if (element.id) {
      window.fitmentFormInstances.set(element.id, instance);
    }
  });
};

window.refreshFitmentFormWraps = function(root = document) {
  window.initializeFitmentFormWraps(root);
  window.fitmentFormInstances.forEach((instance, key) => {
    if (typeof key !== 'string' && !document.contains(key)) {
      instance.destroy();
      window.fitmentFormInstances.delete(key);
      if (key.id) {
        window.fitmentFormInstances.delete(key.id);
      }
      return;
    }

    instance.refresh?.();
  });
};

document.addEventListener('DOMContentLoaded', function() {
  window.initializeFitmentFormWraps();
});

// Handle Shopify section reloads
document.addEventListener('shopify:section:load', function(event) {
  window.initializeFitmentFormWraps(event.target);
});
